import * as types from '@/store/mutation-types';
import companyMutations from './company/companyMutations';
import diaryEntryMutations from './diaryEntry/diaryEntryMutations';
import keywordMutaions from './keyword/keywordMutaions';
import partCommentMutations from './partComment/partCommentMutations';
import personMutations from './person/personMutations';
import projectMutations from './project/projectMutations';
import todoItemMutations from './todoItem/todoItemMutations';
import todoTemplateMutations from './todoItem/todoTemplateMutations';
import inspectionMutations from './inspection/inspectionMutations';
import inspectionTemplateMutations from './inspection/inspectionTemplateMutations';
import undoMutations from './undo/undoMutations';
import Vue from 'vue';

export default {
  ...companyMutations,
  ...diaryEntryMutations,
  ...keywordMutaions,
  ...partCommentMutations,
  ...personMutations,
  ...projectMutations,
  ...todoItemMutations,
  ...todoTemplateMutations,
  ...inspectionMutations,
  ...inspectionTemplateMutations,
  ...undoMutations,
  [types.setSyncStatus](state, status) {
    Vue.set(state, 'syncStatus', status);
  },
  [types.setViewSetting](state, update) {
    state.viewSettings[update.section][update.property] = update.newValue;
  },
  [types.setIsBusy](state, busy) {
    state.isBusy += busy;
  },
  [types.setLoggedIn](state, login) {
    state.loggedin = login;
  },
  [types.setUser](state, user) {
    state.user = user;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js